import { render, staticRenderFns } from "./DecisionsProject.vue?vue&type=template&id=428f04be&scoped=true"
import script from "./DecisionsProject.vue?vue&type=script&lang=js"
export * from "./DecisionsProject.vue?vue&type=script&lang=js"
import style0 from "./DecisionsProject.vue?vue&type=style&index=0&id=428f04be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f04be",
  null
  
)

export default component.exports